import * as go from 'gojs';
import { OrchestrationNodeBindings, OrchestrationUINode } from '../../../../models/orchestration-diagram.model';
import { highlightAncestors, highlightPredecessors } from '../../../utils/highlight-utils';

export const mouseHover = (e: go.InputEvent, object: go.GraphObject): void => {
  try {
    e.diagram.clearHighlighteds();
    const nodeData = (object as go.Node).data as OrchestrationUINode;
    if (nodeData[OrchestrationNodeBindings.DeletedSource]) {
      return;
    }
    highlightPredecessors(object as go.Node);
    highlightAncestors(object as go.Node);
  } catch (err) {
    e.diagram.clearHighlighteds();
  }
};

export const mouseLeave = (e: go.InputEvent): void => {
  e.diagram.clearHighlighteds();
};
